module.exports = __webpack_public_path__ + "static/media/webneat-min.fa0df06a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/webneat-min.jpg
// module id = 882
// module chunks = 0